import type { LearnerCardProps } from '../LearnerCard';
import type { DevelopmentContentRating } from '~/elc/features/learner-development';
import TimeUtils from '~/common/time-utils';
import { I18n } from '~/common/explicit-exports';
import { LearnerCard } from '../LearnerCard';
import { StyledLearnerCard } from './DevelopmentContentCard.styles';

export interface LearnerDevelopmentContentCardProps
  extends Omit<LearnerCardProps, 'iconName' | 'iconColor' | 'metadata'> {
  estimatedTime: number;
  rating?: DevelopmentContentRating;
}

export function DevelopmentContentCard({ estimatedTime, rating, ...props }: LearnerDevelopmentContentCardProps) {
  const RATINGS_COUNT_LABEL = I18n.t('js.learner.development_content.common.ratings');

  // Back-end sends estimatedTime in minutes, so we multiply by 60 to get seconds
  const { timeEstimateDisplayNumber } = TimeUtils.getDisplayTimeEstimate(estimatedTime * 60, true);
  const metadata: LearnerCardProps['metadata'] = [
    {
      iconName: 'clock:regular',
      text: timeEstimateDisplayNumber,
    },
  ];

  if (rating) {
    metadata.push({
      iconName: 'star:regular',
      text: `${rating.score} (${rating.count} ${RATINGS_COUNT_LABEL})`,
    });
  }

  return <LearnerCard {...props} metadata={metadata} className={StyledLearnerCard} />;
}
